import React, { useState } from "react";
import axios, { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'sonner';

export default function ChangePassword() {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<any | null>(null);
    const navigate = useNavigate();

    const handleChangePassword = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        var username = localStorage.force_username;

        if (!username) {
            toast.error(<p className="text-[16px]">Session expired. Please login again.</p>);
            navigate("/login");
            return;
        }

        if (newPassword.length < 8) {
            toast.error("Password must be at least 8 characters.");
            setIsLoading(false);
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match.");
            setIsLoading(false);
            return;
        }

        try {
            const response = await axios.post('https://cdn.pulp.ph/api/changePassword', {
                username,
                newPassword,
                confirmPassword,
            });

            const { status, message } = response.data;

            if (status === "success") {
                toast.success(<p className="text-[16px]">{message}</p>, {
                    duration: 1200,
                });

                localStorage.removeItem("force_username");

                setTimeout(() => {
                    navigate("/login");
                }, 1300);
            }
        } catch (error: unknown) {
            let msg = "Something went wrong.";

            if (axios.isAxiosError(error) && error.response) {
                msg = (error.response.data as any)?.error || msg;
            }

            toast.error(<p className="text-[16px]">{msg}</p>);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col justify-center items-center bg-live bg-black bg-cover bg-no-repeat bg-center h-screen w-screen">
            <form onSubmit={handleChangePassword} className="w-[356px] bg-white p-[30px] rounded-md">
                <div className="mb-3">
                    <h2 className="GraphikSemibold text-center text-[32px] text-black font-semibold">Change Password</h2>
                </div>

                <div className="mb-3">
                    <label htmlFor="newPassword" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1">
                        New Password
                    </label>
                    <div className="flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 pl-3 pr-2">
                        <FontAwesomeIcon icon={faLock} className="text-sm text-gray-400 mr-2" />
                        <input
                            type="password"
                            id="newPassword"
                            className="w-full text-sm tracking-[1px] text-black outline-none bg-white"
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Enter your New Password"
                            required/>
                    </div>
                </div>

                <div className="mb-3">
                    <label htmlFor="confirmPassword" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1">
                        Confirm Password
                    </label>
                    <div className="flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 pl-3 pr-2">
                        <FontAwesomeIcon icon={faLock} className="text-sm text-gray-400 mr-2" />
                        <input
                            type="password"
                            id="confirmPassword"
                            className="w-full text-sm tracking-[1px] text-black outline-none bg-white"
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm your New Password"
                            required/>
                    </div>
                </div>

                {error && (
                    <div className="flex justify-center bg-red-300 bg-opacity-40 border-[1px] border-red-300 p-2 rounded-md error m-0">
                        {Object.keys(error).map((key, index) => (
                            <label className="text-sm tracking-[1px] text-red-600 [text-shadow:0px_0px_1px_#17202A99]" key={index}>
                            <FontAwesomeIcon icon={faCircleExclamation} className="mr-2"/>
                        {error[key]}
                            </label>
                        ))}
                    </div>
                )}

                <div className="flex justify-center mb-1">
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full text-sm tracking-[1px] text-white bg-red-600 hover:bg-red-800 active:transform active:translate-y-[1px] rounded-md p-2 mt-3">
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </div>

                <div className="flex justify-center">
                <label className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] p-2">
                    Already have an account? 
                    <a href="/" className="text-sm tracking-[1px] text-red-600 [text-shadow:0px_0px_1px_#17202A99] hover:text-red-800 ml-1">
                        Login now
                    </a>
                </label>
                </div>
            </form>
        </div>
    );
}